var _rect, _rect2, _rect3, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 5.625,
    fill: "#2B4DFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 23.25,
    height: 23.25,
    rx: 5.625,
    stroke: "white",
    strokeWidth: 0.75
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4218_17832",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4218_17832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 18.2505C7.90625 18.2505 7.61198 18.1281 7.36719 17.8833C7.1224 17.6385 7 17.3442 7 17.0005V10.7505C7 10.4067 7.1224 10.1125 7.36719 9.86768C7.61198 9.62288 7.90625 9.50049 8.25 9.50049H8.875V8.25049C8.875 7.38591 9.17969 6.64893 9.78906 6.03955C10.3984 5.43018 11.1354 5.12549 12 5.12549C12.8646 5.12549 13.6016 5.43018 14.2109 6.03955C14.8203 6.64893 15.125 7.38591 15.125 8.25049V9.50049H15.75C16.0938 9.50049 16.388 9.62288 16.6328 9.86768C16.8776 10.1125 17 10.4067 17 10.7505V17.0005C17 17.3442 16.8776 17.6385 16.6328 17.8833C16.388 18.1281 16.0938 18.2505 15.75 18.2505H8.25ZM12 15.1255C12.3438 15.1255 12.638 15.0031 12.8828 14.7583C13.1276 14.5135 13.25 14.2192 13.25 13.8755C13.25 13.5317 13.1276 13.2375 12.8828 12.9927C12.638 12.7479 12.3438 12.6255 12 12.6255C11.6562 12.6255 11.362 12.7479 11.1172 12.9927C10.8724 13.2375 10.75 13.5317 10.75 13.8755C10.75 14.2192 10.8724 14.5135 11.1172 14.7583C11.362 15.0031 11.6562 15.1255 12 15.1255ZM10.125 9.50049H13.875V8.25049C13.875 7.72966 13.6927 7.28695 13.3281 6.92236C12.9635 6.55778 12.5208 6.37549 12 6.37549C11.4792 6.37549 11.0365 6.55778 10.6719 6.92236C10.3073 7.28695 10.125 7.72966 10.125 8.25049V9.50049Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.237f0d4639bcb78451e3d5356058456f.svg";
export { ForwardRef as ReactComponent };